import React from 'react';
import { Calculator as CalcIcon } from 'lucide-react';
import { useT } from '../utils/i18n';
import { MaterialCalculator } from '../components/MaterialCalculator';
export function Calculator() {
  const t = useT();
  return <main className="py-12 md:py-20 bg-[#fdfbf7] dark:bg-[#222222] min-h-[calc(100vh-64px)]" data-id="element-2057" data-mp="157c6kxq3wkqv">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2058" data-mp="10esr1v7uzfjf">
        <div className="mb-8 text-center md:text-left" data-id="element-2059" data-mp="1e6yvwl5ka03k">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-brand-charcoal dark:text-white flex items-center justify-center md:justify-start" data-id="element-2060" data-mp="1e5ffmujwnp1s">
            <CalcIcon className="w-8 h-8 mr-3 text-brand-orange" data-id="element-2061" data-mp="1o5y4k3qbtvqk" />
            {t('calc.title')}
          </h1>
          <p className="text-stone-700 dark:text-stone-300 mt-2 text-lg" data-id="element-2062" data-mp="1j7d72c2glq5t">
            {t('calc.subtitle')}
          </p>
        </div>
        <MaterialCalculator variant="page" data-id="element-2063" data-mp="3px1j343c7uge" />
      </div>
    </main>;
}